import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { GET, POST } from "../../utils/apicalls";
import { API } from "../../config/api";
import PageHeader from "../pageHeader/pageheader";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";

function LeaveDetailsAdmin() {
  const [formSearch] = Form.useForm();  // For searching leave records
  const [formModal] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const [data2, setData2] = useState<any>([]);
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [employeeData, setEmployeeData] = useState<any>([]);
  const navigate = useNavigate();

  const columns = [
    {
      dataIndex: "type",
      title: "Type",
    },
    {
      dataIndex: "approver",
      title: "Approver",
    },
    {
      dataIndex: "from",
      title: "From",
      render: (from: any) => (from ? moment(from).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "to",
      title: "To",
      render: (to: any) => (to ? moment(to).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (status: any) => {
        let color = "";
        switch (status?.toLowerCase()) {
          case "approved":
            color = "green";
            break;
          case "rejected":
            color = "red";
            break;
          default:
            color = "black"; // Default color for other statuses
        }
        return <span style={{ color }}>{status}</span>;
      },
    },
    {
      dataIndex: "employeeId",
      title: "Employee",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    {
      dataIndex: "description",
      title: "Description",
    },
    {
      dataIndex: "createdBy",
      title: "Created By",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Admin/leave-update/${record.id}`)} // Use navigate with a route
          />
        </Space>
      ),
    },
  ];

  const submitHandler = async (values: any) => {
    try {
      const obj = {
        employeeId: values.employeeId,
        salaryId: values.salaryId,
        leaveId: values.leaveId,
        approver: values.approver,
        from: values.from?.format("YYYY-MM-DD"),
        to: values.to?.format("YYYY-MM-DD"),
        type: values.type,
        status: values.status,
        description: values.description,
        createdBy: values.createdBy,
      };

      setIsLoading(true);
      const api = API.CREATE_LEAVE;
      const postRequest: any = await POST(api, obj);
      if (postRequest.status) {
        notification.success({ message: "Leave created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        formModal.resetFields();
        fetchLeave(page, pageSize);
      } else {
        notification.error({ message: "Something went wrong!" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
      setIsLoading(false);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    formModal.resetFields();
  };
  // Function to search leave with filters
  const SearchLeave = async (values: any) => {
    try {
      setIsLoading(true);
      const obj = {
        query: formSearch.getFieldValue("query"),
        status: values.status,
        month: values.month, // Pass the selected month
        employeeId: values?.employeeId, // Pass the selected employee
        page: page,
        take: pageSize,
      };
      const url = API.SEARCH_LEAVE;
      const response: any = await POST(url, obj);
      setData2(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLeave = async (page: any, pageSize: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: formModal.getFieldValue("query"),
        page: page,
        take: pageSize,
      };
      const url = API.LIST_LEAVE;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLeave(page, pageSize);
    fetchEmployee();
  }, [page, pageSize]);

  const fetchEmployee = async () => {
    try {
      setIsLoading(true);
      const url = API.EMPLOYEE_LISTING;
      const data: any = await GET(url, {});
      if (data?.data) {
        setEmployeeData(data?.data);
      } else {
        console.error("Unexpected data format:", data);
        setEmployeeData([]); // Set to an empty array to prevent errors
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setEmployeeData([]); // Handle errors by setting to an empty array
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageHeader>
        <Row
          gutter={16}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Col>
            <Button type="primary" onClick={showModal} style={{ marginRight: "10px" }}>
              Create Leave
            </Button>
          </Col>
        </Row>
      </PageHeader>

      <Modal
        title="Create Leave"
        open={isModalOpen}
        onCancel={handleCancel}
        width={1000}
        footer={null} // Ensure no extra submit button outside the form
      >
        <Form form={formModal} onFinish={submitHandler} layout="vertical">

          <Row gutter={16}>
            <Col sm={6}>
              {employeeData && (
                <Form.Item
                  label=" Name"
                  name="employeeId"
                  style={{ marginBottom: 10 }}
                  rules={[{ required: true, message: "Select an employee" }]}
                >
                  <Select placeholder="Select a Name" size="large">
                    {employeeData?.map((users: any) => (
                      <Select.Option key={users?.id} value={users?.id}>
                        {users?.fullName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>

            <Col sm={6}>
              <Form.Item name="from" label="From" rules={[{ required: true }]}>
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item name="to" label="To" rules={[{ required: true }]}>
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="description"
                label="Description"
                rules={[{ required: true }]}
              >
                <Input.TextArea placeholder="Enter description" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item name="type" label="Leave Type" rules={[{ required: true }]}>
                <Select placeholder="Select leave type">
                  <Select.Option value="sick">Sick</Select.Option>
                  <Select.Option value="vacation">Vacation</Select.Option>
                  <Select.Option value="maternity">Maternity</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="createdBy"
                label="Created By"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select ">
                  <Select.Option value="admin">admin</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item name="status" label="Status" rules={[{ required: true }]}>
                <Select placeholder="Select status">
                  <Select.Option value="approved">Approved</Select.Option>
                  <Select.Option value="rejected">Rejected</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={isLoading} block>
                  Create Leave
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Card>
        <Form form={formSearch} onFinish={SearchLeave} layout="vertical">

          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                label="Employee Name"
                name="employeeId"
                style={{ marginBottom: 10 }}
              >
                <Select
                  placeholder="Select an employee"
                  size="large"
                  allowClear
                >
                  {employeeData?.map((user: any) => (
                    <Select.Option key={user?.id} value={user?.id}>
                      {user?.fullName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* Month Filter */}
            <Col sm={6}>
              <Form.Item
                label="Month"
                name="month"
                style={{ marginBottom: 10 }}
              >
                <Select placeholder="Select a month" size="large" allowClear>
                  {Array.from({ length: 12 }, (_, i) => (
                    <Select.Option key={i + 1} value={i + 1}>
                      {moment().month(i).format("MMMM")}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                label="Status"
                name="status"
                style={{ marginBottom: 10 }}
              >
                <Select placeholder="Select Status" size="large" allowClear>
                  <Select.Option value="approved">Approved</Select.Option>
                  <Select.Option value="rejected">Rejected</Select.Option>
                  <Select.Option value="requested">Requested</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Search
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      <Table
        columns={columns}
        dataSource={
          data2.length ? data2 : data
        }
        pagination={{
          current: page, // current page number
          pageSize: pageSize, // number of items per page
          total: meta?.total, // total items count
          showSizeChanger: true, // Show option to change the page size
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Page size options
          onChange: (page: number, pageSize: number) => {
            setPage(page); // Set the current page
            setPageSize(pageSize); // Set the page size
            fetchLeave(page, pageSize); // Fetch the data based on the updated page and page size
          },
        }}
        loading={isLoading} // Show loading state while fetching data
      />
    </>
  );
}

export default LeaveDetailsAdmin;
